import React from 'react';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import AutoComplete from 'components/molecules/autocompleteFilter';
import forms from 'constants/forms';
import AutoCompleteDoctorMultiSelect from 'components/molecules/autocompleteFilter/doctorMulti';
import MonthPicker from 'components/molecules/datepicker/monthPicker';

const DEFAULT_FILTER = forms.patientFilterOptions[0];

const Sorting = () => {
  const {
    compliance: { applyTimeFilter, applyFilters },
  } = useDispatch();
  const complianceReport = useSelector((state) => state.compliance);

  const filter = DEFAULT_FILTER;

  const updateFilter = ({ year, month }) => {
    applyTimeFilter({ year, month });
  };

  const changePatientFilter = (option) => {
    if (option) {
      applyFilters({ patientGuid: option.value });
    }
  };
  return (
    <Row>
      <Col xl="2" xs="12" md="6">
        <p>Report Time Window</p>
        <MonthPicker
          value={{ year: complianceReport.year, month: complianceReport.month }}
          onChange={(value) => {
            if (!value) {
              const now = new Date();
              updateFilter({
                year: now.getFullYear(),
                month: now.getMonth() + 1,
              });
            } else {
              updateFilter({ year: value.year, month: value.month });
            }
          }}
        />
      </Col>
      <Col xl="2" xs="12" md="6">
        <p>Provider</p>
        <AutoCompleteDoctorMultiSelect
          filter={filter}
          onChange={(doctorGuid) => {
            applyFilters({ doctorGuid });
          }}
        />
      </Col>
      <Col xl="2" xs="12" md="6">
        <p>Patient Name</p>
        <AutoComplete filter={filter} handleClick={changePatientFilter} />
      </Col>
    </Row>
  );
};

export default Sorting;
